import React, {
  useContext,
  useCallback,
  useRef,
  useState,
  useEffect,
} from "react";
import { motion, AnimatePresence } from "framer-motion";
// import MorphSVGPlugin from "../../../resources/MorphSVGPlugin";
// import SplitText from "../../../resources/SplitText";
import Segment from "./segment/Segment";
import IconsWheel from "../iconsWheel/IconsWheel";
import ProfilePic from "../profilePic/ProfilePic";

import WheelSizeContext from "../../contexts/WheelSizeContext";
import LifeAreasContext from "../../contexts/LifeAreasContext";

// import iraPic from "../../assets/images/ira.jpg";
import style from "./Wheel.module.css";

type WheelProps = {
  profilePic: string;
  animateToMax: boolean;
  disabled: boolean;
  goToArea: (key: string) => void;
};

const Wheel = ({
  profilePic,
  animateToMax,
  disabled,
  goToArea,
}: WheelProps) => {
  const wheelSize = useContext(WheelSizeContext);

  const { lifeAreas: areas, dispatchLifeAreas } = useContext(LifeAreasContext);

  // When an area is being scored the wheel rotates round to focus on it.
  const [wheelRotation, setWheelRotation] = useState(0);
  const rotateDuration = 0.8;

  // TODO: Move to utils
  const calculateCircleChordLength = () => {
    const angle = 360 / areas.keys.length;
    const a2 = convertDegreesToRadians(angle / 2);
    const radius = wheelSize / 2 / Math.cos(a2);
    const chord = 2 * radius * Math.sin(a2) + 2;
    return chord;
  };
  // const convertRadiansToDegrees = radians => radians * (180 / Math.PI);
  const convertDegreesToRadians = (deg: number) => deg * (Math.PI / 180);

  const areaWidth = calculateCircleChordLength();
  // const averagePercent = Math.round(returnAverageScore() * 10)

  const areaTapped = useCallback(
    (key: string) => {
      if (disabled) return;
      goToArea(key);
    },
    [disabled, goToArea]
  );

  const segments = areas.keys.map((key: string, index: number) => {
    // const bgColour = index % 2 ? colourScheme[1] : colourScheme[2];
    const areaRotation = (360 / areas.keys.length) * index;
    const rotation = `rotate(${areaRotation}deg`;
    const areaScore = (areas.scores && areas.scores[key]) || 65;
    return (
      <div
        key={key}
        className={style.segment}
        // onClick={() => areaTapped(key)}
        style={{
          height: wheelSize / 2,
          width: areaWidth,
          transform: rotation,
          transformOrigin: "50% 100%",
          cursor: disabled ? "initial" : "pointer",
        }}
      >
        <Segment
          areaKey={key}
          areaRotation={areaRotation}
          wheelRotation={wheelRotation}
          score={areaScore}
          profilePic={profilePic}
          animateToMax={animateToMax}
        />
      </div>
    );
  });

  return (
    // Add outer containr
    <AnimatePresence initial={true}>
      <motion.div
        className={style.container}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <div
          className={style.circleContainer}
          style={{
            width: wheelSize,
            height: wheelSize,
          }}
        >
          <div
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              borderRadius: "50%",
              // transform: `rotate(${0 - (areaRotation + wheelRotation)}deg)`,
            }}
          >
            <ProfilePic isBlurred={true} size={wheelSize} src={profilePic} />
          </div>
          <motion.div
            className={style.segments}
            animate={{ rotate: wheelRotation }}
            // Transition needs to match the image rotation in the scoring wheel
            transition={{ duration: rotateDuration, ease: "linear" }}
          >
            {segments}
          </motion.div>
        </div>
        {/* <motion.div
        className={style.valuesIcons}
        style={{ pointerEvents: "none" }}
        animate={{ rotate: wheelRotation }}
        transition={{ duration: rotateDuration, ease: "linear" }}
      > */}
        <IconsWheel
          wheelRotation={wheelRotation}
          onTap={areaTapped}
          disabled={disabled}
        />
        {/* </motion.div> */}
      </motion.div>
    </AnimatePresence>
  );
};

export default Wheel;

// const returnAverageScore = () => {
//   let total = 0
//   Object.values(areas).forEach(score => {
//     total += score
//   })
//   return total / Object.values(areas).length.toFixed(2)
// }
